import { useHistory, useLocation } from 'react-router-dom';
import { useRef } from 'react';
import { GetUserAccess } from '../helper/module';

/**
 * useGoToNewOrder
 * - targetPath: مسیر هدف (پیش‌فرض "/neworder")
 * - useReplace: اگر true باشد از history.replace استفاده می‌کند (به جای push)
 * - debounceMs: مدت زمان محدودسازی دوباره‌کلیک (مثلاً 600ms). اگر 0 یا کمتر باشد هیچ Debounce‌ای اعمال نمی‌شود.
 * - avoidDuplicates: اگر true باشد جلوی رفتن به همان مسیر فعلی را می‌گیرید
 */
function useGoToNewOrder({
  targetPath = '/neworder',
  useReplace = false,
  debounceMs = 600,
  avoidDuplicates = true,
} = {}) {


  const history = useHistory();
  const location = useLocation();
  const canNavigate = useRef(true);
  const lastPath = location.pathname;

  const goToNewOrder = () => {
      if(!GetUserAccess().loaded || !GetUserAccess().newOrder){
    return
  }
    if (avoidDuplicates && location.pathname === targetPath) {
      // الان در targetPath است، دوباره push نکن
      return;
    }

    if (!canNavigate.current) return;
    canNavigate.current = false;

    if (useReplace) {
      history.replace(targetPath);
    } else {
      history.push(targetPath);
    }

    // فعال سازی مجدد با Debounce
    if (debounceMs > 0) {
      setTimeout(() => {
        canNavigate.current = true;
      }, debounceMs);
    } else {
      canNavigate.current = true;
    }
  };

  return { goToNewOrder };
}

export default useGoToNewOrder;
